import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronDown, BookOpen, Images } from "lucide-react";
import { useApp } from "../context/AppContext";
import { EXPLORE_GROUPS, KIND_LABEL } from "../explore";

export default function ExploreMenu() {
  const { lang, t } = useApp();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const active = /^\/(varieties|oases|routes|stories|gallery|culinary)/.test(pathname);

  useEffect(() => setOpen(false), [pathname]);
  useEffect(() => {
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("pointerdown", onDoc);
    return () => document.removeEventListener("pointerdown", onDoc);
  }, []);

  return (
    <div
      ref={ref}
      className={`explore-wrap ${open ? "open" : ""}`}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <button
        className={`nav-link explore-trigger ${active ? "active" : ""}`}
        onClick={() => setOpen((o) => !o)}
        aria-haspopup="true"
        aria-expanded={open}
        data-testid="nav-explore-trigger"
      >
        {t("nav.explore")}
        <ChevronDown size={14} className="explore-chevron" />
      </button>

      <div className="explore-panel glass-card" role="menu" data-testid="explore-panel">
        <div className="explore-grid">
          {EXPLORE_GROUPS.map((g) => (
            <div key={g.id} className="explore-col">
              <Link to={g.to} className="explore-col-title" data-testid={`explore-group-${g.id}`}>
                {g.label[lang]}
              </Link>
              {g.items.map((it) => (
                <Link key={it.slug} to={it.to} className="explore-item" data-testid={`explore-item-${it.slug}`}>
                  {it.label[lang]}
                </Link>
              ))}
            </div>
          ))}
        </div>
        <div className="explore-foot">
          <Link to="/stories" className="explore-stories" data-testid="explore-stories-link">
            <BookOpen size={16} />
            <span>
              <strong>{KIND_LABEL.stories[lang]}</strong>
              <small>{t("nav.exploreStoriesSub")}</small>
            </span>
          </Link>
          <Link to="/gallery" className="explore-stories" data-testid="explore-gallery-link">
            <Images size={16} />
            <span>
              <strong>{KIND_LABEL.gallery[lang]}</strong>
              <small>{t("gallery.sub")}</small>
            </span>
          </Link>
        </div>
      </div>
    </div>
  );
}
